export const Bio = {
  name: "Sanjula Dulshan",
  roles: [
    "Full Stack Developer",
    "Backend Developer",
    "Mobile App Developer",
    "Programmer",
  ],
  description:
    "I am an optimistic and creative full-stack engineer with 2+ years of experience in most javaScript-related technologies in backend development. Also, I have experience in React and Angular with front-end development. I'm highly skilled at understanding key requirements and providing unique and creative solutions to meet customer requirements best. I'm continuously learning all the things I would like to do in the future.",
  github: "https://github.com/Sanjula-Dulshan",
  hackerRank: "https://www.hackerrank.com/profile/sdulshan10",
  resume:
    "https://drive.google.com/file/d/17YKdxbir9YT8pEbhX9_BO9W0h0D6u6c7/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sanjula-dulshan-154329203/",

  whatsapp: "https://api.whatsapp.com/send?phone=94719647830",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Angular",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1696445307/portfolio/Icons/gupj1peozainysttkchb.svg",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },

      {
        name: "Nest Js",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1696445822/portfolio/Icons/ux0hgmttvbjddt8duxn8.svg",
      },

      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "C#",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1696445669/portfolio/Icons/czn45w3de3a40x3zcqnx.png",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "React Native",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },

      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "AWS",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1696446328/portfolio/Icons/r3efe172dqof4woy0bmg.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1696446432/portfolio/Icons/bpyhkrvunyd0mydye2yl.svg",
      },
      {
        name: "Git",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1704184231/portfolio/Icons/dogaejdaztqyis49n1g2.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },

      {
        name: "Postman",
        image:
          "https://res.cloudinary.com/waste123/image/upload/v1704184280/portfolio/Icons/icu0xa1i1hklspdoznxz.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/waste123/image/upload/v1696446766/portfolio/Icons/oj1enkh6mvyec1l8tho0.jpg",
    role: "Software Engineering Internship",
    company: "eBuilder Technology Center Pvt Ltd.",
    date: "Jun 2022 - Dec 2022",
    desc: "Working on Web application using ReactJS, NodeJS, DynamoDB, and AWS. Following Agile Methodology",
    skills: [
      "AWS",
      "ReactJS",
      "Node Js",
      "DynamoDB",
      "Git",
      "Code Commit",
      "Agile",
      "Jira",
    ],
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/waste123/image/upload/v1696446766/portfolio/Icons/oj1enkh6mvyec1l8tho0.jpg",
    role: "Software Engineering Apprenticeship",
    company: "eBuilder Technology Center Pvt Ltd.",
    date: "Dec 2022 - Jun 2023",
    desc: "Working on Web application using ReactJS, NodeJS, DynamoDB, and AWS. Following Agile Methodology",
    skills: [
      "AWS",
      "ReactJS",
      "Node Js",
      "DynamoDB",
      "Git",
      "Code Commit",
      "Agile",
      "Jira",
    ],
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/waste123/image/upload/v1696447681/portfolio/Icons/eyhr3ayfst4hgmkneyhy.jpg",
    role: "Associate Software Engineer",
    company: "EchonLabs (Pvt) Ltd",
    date: "June 2023 - Dec 2023",
    desc: "Working on Web application using Angular, NestJS, and MongoDB",
    skills: ["Angular", "Nest Js", "MongoDB", "Git Lab", "Agile"],
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/waste123/image/upload/v1735556305/portfolio/Icons/pvgafjhcnvei76kkyzpd.jpg",
    role: "Associate Software Engineer",
    company: "i-wonder sri lanka",
    date: "March 2024 - Present",
    desc: "Working on Web application using .Net, C#, Angular, SQL and MongoDB",
    skills: ["Angular", ".Net","C#", "MongoDB", "SQL", "Azure"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/waste123/image/upload/v1696448090/portfolio/Icons/hubl1ghghfo74pvwrbnh.jpg",
    school: "Sri Lanka Institute of Information Technology",
    date: "Jan 2020 - Jan 2024",
    grade: "3.33 CGPA",
    desc: "I graduated from SLIIT with a BSc (Hons) in Information Technology",
  },
];

export const projects = [
  {
    id: 1,
    title: "Authentication with OAuth 2.0",
    description:
      "This is a backend application that enables users to log in using OAuth 2.0. It also includes features for password reset, and email verification. Logged-in users have the ability to update their profile and change their password, while admin users can view all users.",

    image:
      "https://res.cloudinary.com/waste123/image/upload/v1696514807/portfolio/p1vepxmh67dhnxlfua2n.png",
    tags: [
      "Node Js",
      "Express Js",
      "MongoDB",
      "OAuth 2.0",
      "JWT",
      "Nodemailer",
    ],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/Login",
  },
  {
    id: 2,
    title: "Netflix Redesign",

    description:
      "Netflix clone is a web application that allows users to watch movies and TV shows online. It is a clone of the original Netflix website.",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1696515085/portfolio/h1orw2wkeks5bllrwhfm.png",
    tags: ["React Js", "Firebase Hosting", "CSS"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/netflix_clone",
    webapp: "https://netflix-clone-56d39.web.app/",
  },
  {
    id: 3,
    title: "Responsive Tour & Travel Website",
    description:
      "This is a responsive website for a travel agency. It is built using HTML, CSS, and jQuery.",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1696516498/portfolio/xnxoyxtfdc2bzz1kzsat.png",
    tags: ["HTML", "CSS ", "jQuery"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/travel_website",
    webapp: "https://sanjula-dulshan.github.io/travel_website/",
  },
  {
    id: 4,
    title: "CryptoCurrency Price Tracker",
    description:
      "CryptoCurrency Price Tracker is a web application that allows users to track the price of cryptocurrencies. It is built using Angular, HTML, CSS, and CoinGecko API.",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672422659/portfolio/mloqnynhfvn6kcxvbgom.png",
    tags: ["Angular", "HTML", "CoinGecko API"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/Crypto-Checker",
  },
  {
    id: 5,
    title: "Waste Management System (ecoBin)",
    description:
      "“ecoBin” is a system which provides connection between the people who want to get rid of their wastes and the parties which can get benefits from them. It is built using React js, Node js, Mongo DB, Express js and Bootstrap",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672423751/portfolio/nn06gkikprvigaibgb86.png",
    tags: ["React Js", "Node Js", "MongoDB", "Express Js", "Bootstrap"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/ITP-Waste-Management-System",
  },
  {
    id: 6,
    title: "Reseach Management Tool",
    description:
      "The research management tool is a new self-contained software product which will be produced by the project team in order to overcome the problems that have occurred due to the current manual system. This tool will provide an easy access to the system and it will contain user friendly functions with attractive interfaces. The system will give better options for the problem of handling large scale of physical research file system, for the errors occurring in calculations and all the other required tasks that has been specified by the student. It is built using React js, Node js, Mongo DB, Express js, Bootstrap and Material-UI",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672424426/portfolio/zjzbqvabzzkzdhdubdui.png",
    tags: [
      "React Js",
      "Node Js",
      "MongoDB",
      "Express Js",
      "Axios",
      "Bootstrap",
      "Material-UI",
    ],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/Research-Management-Tool",
  },
  {
    id: 7,
    title: "Classy Service",
    description:
      "Classy service is a portal which connect different types of service providers to the service seekers. It has variety of services. Service providers can easily register to the system and find their buyers. People who seek for a particular service are able to search and find the best service provider according to the reviews or price. They can purchase the service through the system. All purchase and service histories will be available on their profiles. It is built using React js, Node js, Mongo DB, Express js and Bootstrap",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672424580/portfolio/kvqmq0scogzd0is2gune.png",
    tags: ["React Js", "Node JS", "MongoDB", "Express Js", "Bootstrap"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/Classy-service",
  },
  {
    id: 8,
    title: "'bookMark' - The only book store app you need",
    description:
      "bookMark is a mobile application that allows users to buy and sell books. It is built using Android studio and Firebase",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672425182/portfolio/rnmkwri11qjdkth82i87.png",
    tags: ["Android studio", "Firebase", "Java"],
    category: "android app",
    github: "https://github.com/Sanjula-Dulshan/bookMark-DevApps_MAD",
  },
  {
    id: 9,
    title: "Uber Eats Clone",
    description:
      "This app app allows users to search for restaurants within a specified location using the Google place API, filter between delivery and pickup options, browse menus and add items to a cart which is saved even when the user exits the app. The total price is displayed and updates in real-time. When the user clicks the checkout button, the order details are added to a Firebase Firestore database and the user is taken to an order complete screen where they can view the items in their order. It is built using React Native, Redux, Firebase Yelp API and Google place API.",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1672425857/portfolio/g5nqidy9wxeye64d6qou.png",
    tags: ["React Native", "Redux", "Firebase", "Yelp API", "Google place API"],
    category: "android app",
    github: "https://github.com/Sanjula-Dulshan/Uber-Eat-Clone",
  },
  {
    id: 10,
    title: "Task Management",
    description:
      "Task Management is a web application that allows users to manage their tasks. It is built using Next js, Node js, Mongo DB, Express js and Typescript",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1704185539/portfolio/trlk7oziqjj543avuhkm.png",
    tags: ["Next Js", "Node Js", "MongoDB", "Express Js", "Typescript"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/Task-Management-CDAZZDEV",
  },
  {
    id: 11,
    title: "Share File",
    description:
      "Share File is a web application that allows users can upload a file and share the link with friend or directly mail the link to anyone. It is built using Next js, Node js, Mongo DB, Express js and Typescript",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1704186236/portfolio/wwrs3ffannucli1sbwmv.png",
    tags: ["Next Js", "Node Js", "MongoDB", "Express Js", "Typescript"],
    category: "web app",
    github: "https://github.com/Sanjula-Dulshan/File-Share",
  },
  {
    id: 12,
    title: "MangoWise",
    description:
      "This is the our final year research project. Our main objective is to  identify and analyze challenges faced in mango cultivation to maximize profits. Int this app we provide facilities to determining the optimal timing for budding, identifying suitable varieties, managing diseases, proper fertilization, and knowledge dissemination gaps, with the goal of providing recommendations for improving cultivation practices and profitability.",
    image:
      "https://res.cloudinary.com/waste123/image/upload/v1704195163/portfolio/eq6u0lti4gsz5hlubsgg.jpg",
    tags: [
      "React Native",
      "Node Js",
      "MongoDB",
      "Express Js",
      "YOLOv8",
      "Machine Learning",
      "Google Cloud",
    ],
    category: "android app",
    github: "https://github.com/Sanjula-Dulshan/MangoWise",
  },
];
